








































import {
  DynamicDocumentItem,
  InstallationModuleData,
  Material,
  Nullable,
  SerialNumber
} from "@/types";

import Vue, { PropType } from "vue";
import InverterConfigurationManager from "@/containers/inverter-configuration-manager/InverterConfigurationManager.vue";

export default Vue.extend({
  components: {
    InverterConfigurationManager
  },
  props: {
    item: Object as PropType<DynamicDocumentItem>,
    moduleData: Object as PropType<InstallationModuleData>
  },

  data() {
    return {
      editMode: false,
      inverterConfigId: null as Nullable<number>
    };
  },

  created() {
    if (this.moduleData.inverterConfiguration && this.moduleData.inverterConfiguration.length > 0) {
      this.inverterConfigId = Number(this.moduleData.inverterConfigurationId);
    }
  },

  methods: {
    beforeSave() {
      this.$set(this.moduleData, "inverterConfigurationId", this.inverterConfigId);
      this.checkForInverterSerialNumberUpdate();
      this.save();
    },
    save() {
      this.$emit("save:module");
    },
    checkForInverterSerialNumberUpdate() {
      const moduleData: InstallationModuleData = this.moduleData;
      if (moduleData) {
        const newInverterSerialNumberCount =
          moduleData.inverterConfiguration?.reduce((a, b) => a + b.amount, 0) || 0;
        const currentInverterSerialNumberCount = this.moduleData.inverterSerialNumbers?.length || 0;
        if (newInverterSerialNumberCount < currentInverterSerialNumberCount) {
          this.$set(
            this.moduleData,
            "inverterSerialNumbers",
            moduleData.inverterSerialNumbers?.slice(0, newInverterSerialNumberCount)
          );
        } else if (newInverterSerialNumberCount > currentInverterSerialNumberCount) {
          const extra: SerialNumber[] = new Array(
            newInverterSerialNumberCount - currentInverterSerialNumberCount
          )
            .fill(null)
            .map(() => ({ serialNumber: "", source: "manual" } as SerialNumber));
          this.$set(this.moduleData, "inverterSerialNumbers", [
            ...(moduleData.inverterSerialNumbers || []),
            ...extra
          ]);
        }
      }
    }
  },

  computed: {
    inverterConfigurationId: {
      get(): number | null {
        return this.moduleData.inverterConfiguration &&
          this.moduleData.inverterConfiguration.length > 0
          ? Number(this.moduleData.inverterConfigurationId)
          : null;
      },
      set(val: number) {
        this.inverterConfigId = val;
      }
    },
    inverters(): Material[] {
      const configurations = this.$store.state.materials.inverterConfigurations.items;

      const availableConfigurations = configurations.filter(
        ({ available }: Material) => available === true
      );
      const unavailableConfiguration = configurations.find(
        ({ id }: Material) => id === this.moduleData.inverterConfigurationId
      );

      if (unavailableConfiguration) {
        return [...availableConfigurations, unavailableConfiguration];
      }
      return availableConfigurations;
    },
    isPending(): boolean {
      return this.$store.getters["installation/isPending"];
    },
    maxPanelCount(): boolean {
      if (this.moduleData.inverterConfiguration?.length && this.moduleData.numberOfPanels) {
        return (
          this.moduleData.inverterConfiguration
            ?.flatMap(({ amount, max_panel_count }) => amount * max_panel_count)
            ?.reduce((a, b) => a + b) < this.moduleData.numberOfPanels
        );
      } else {
        return false;
      }
    }
  }
});
